import { skipToken, useQuery } from '@tanstack/react-query';
import { oauthClientsApi } from '@/lib/api/oauth-clients';
import { oauthClientsQueryKeys } from '@/lib/query-keys/oauth-clients';

export const useOauthClientsQuery = () =>
  useQuery({
    queryKey: oauthClientsQueryKeys.list(),
    queryFn: () => oauthClientsApi.list(),
  });

export const getOauthClientQueryOptions = (id: string) => ({
  queryKey: oauthClientsQueryKeys.detail(id),
  queryFn: () => oauthClientsApi.get(id),
});

export const useOauthClientQuery = (id: string | null) =>
  useQuery({
    queryKey: id !== null ? oauthClientsQueryKeys.detail(id) : oauthClientsQueryKeys.all(),
    queryFn: id !== null ? () => oauthClientsApi.get(id) : skipToken,
  });
